import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { ERouterName } from '/@/types/index'
import CreatePlan from '/@/components/task/CreatePlan.vue'
import WaylinePanel from '/@/pages/page-web/projects/wayline.vue'
import DockPanel from '/@/pages/page-web/projects/dock.vue'
import LiveAgora from '/@/components/livestream-agora.vue'
import LiveOthers from '/@/components/livestream-others.vue'
import LiveSecCam from '/@/components/livestream-seccam.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/' + ERouterName.STATION_LOGIN
    // redirect: '/' + ERouterName.PROJECT
  },
  // Station project (Hanwha user station project)
  {
    path: '/' + ERouterName.STATION_LOGIN,
    name: ERouterName.STATION_LOGIN,
    component: () => import('/@/pages/page-station/index.vue')
  },
  {
    path: '/' + ERouterName.STATION_MAIN,
    name: ERouterName.STATION_MAIN,
    component: () => import('/@/pages/page-station/main.vue'),
    redirect: '/' + ERouterName.STATION_HOME,
    children: [
      {
        path: '/' + ERouterName.STATION_HOME,
        name: ERouterName.STATION_HOME,
        component: () => import('/@/pages/page-station/items/home.vue')
      },
      {
        path: '/' + ERouterName.STATION_PROJECT,
        name: ERouterName.STATION_PROJECT,
        component: () => import('/@/pages/page-station/items/project.vue')
      },
      {
        path: '/' + ERouterName.STATION_LIBRARY,
        name: ERouterName.STATION_LIBRARY,
        component: () => import('/@/pages/page-station/items/library.vue')
      },
      {
        path: '/' + ERouterName.STATION_VOLUME,
        name: ERouterName.STATION_VOLUME,
        component: () => import('/@/pages/page-station/items/volume.vue')
      },
      {
        path: '/' + ERouterName.STATION_HATS,
        name: ERouterName.STATION_HATS,
        component: () => import('/@/pages/page-station/items/hats.vue')
      },
      {
        path: '/' + ERouterName.STATION_SETTING,
        name: ERouterName.STATION_SETTING,
        component: () => import('/@/pages/page-station/items/setting.vue')
      }
    ]
  },
  // 首页
  {
    path: '/' + ERouterName.PROJECT,
    name: ERouterName.PROJECT,
    component: () => import('/@/pages/page-web/index.vue')
  },
  // members, devices
  {
    path: '/' + ERouterName.HOME,
    name: ERouterName.HOME,
    component: () => import('/@/pages/page-web/home.vue'),
    children: [
      {
        path: '/' + ERouterName.MEMBERS,
        name: ERouterName.MEMBERS,
        component: () => import('/@/pages/page-web/projects/members.vue')
      },
      {
        path: '/' + ERouterName.DEVICES,
        name: ERouterName.DEVICES,
        component: () => import('/@/pages/page-web/projects/devices.vue')
      },
      {
        path: '/' + ERouterName.FIRMWARES,
        name: ERouterName.FIRMWARES,
        component: () => import('../pages/page-web/projects/Firmwares.vue')
      }
    ]
  },
  // workspace
  {
    path: '/' + ERouterName.WORKSPACE,
    name: ERouterName.WORKSPACE,
    component: () => import('/@/pages/page-web/projects/workspace.vue'),
    redirect: '/' + ERouterName.TSA,
    children: [
      {
        path: '/' + ERouterName.TSA,
        component: () => import('/@/pages/page-web/projects/tsa.vue')
      },
      {
        path: '/' + ERouterName.MAP_AREA,
        name: ERouterName.MAP_AREA,
        component: () => import('/@/pages/page-web/projects/maparea.vue')
      },
      {
        path: '/' + ERouterName.MAP_CLIP,
        name: ERouterName.MAP_CLIP,
        component: () => import('/@/pages/page-web/projects/mapclip.vue')
      },
      {
        path: '/' + ERouterName.MAP_TASK,
        name: ERouterName.MAP_TASK,
        component: () => import('/@/pages/page-web/projects/maptask.vue')
      },
      {
        path: '/' + ERouterName.LIVESTREAM,
        name: ERouterName.LIVESTREAM,
        component: () => import('/@/pages/page-web/projects/livestream.vue'),
        children: [
          {
            path: ERouterName.LIVING,
            name: ERouterName.LIVING,
            components: {
              LiveAgora,
              LiveOthers,
              LiveSecCam,
            }
          }
        ]
      },
      {
        path: '/' + ERouterName.LAYER,
        name: ERouterName.LAYER,
        component: () => import('/@/pages/page-web/projects/layer.vue')
      },
      {
        path: '/' + ERouterName.MEDIA,
        name: ERouterName.MEDIA,
        component: () => import('/@/pages/page-web/projects/media.vue')
      },
      {
        path: '/' + ERouterName.FLIGHT_PARAMS,
        name: ERouterName.FLIGHT_PARAMS,
        component: () => import('/@/pages/page-web/projects/flight-params.vue'),
      },
      {
        path: '/' + ERouterName.WAYLINE,
        name: ERouterName.WAYLINE,
        component: () => import('/@/pages/page-web/projects/wayline.vue'),
      },
      {
        path: '/' + ERouterName.TASK,
        name: ERouterName.TASK,
        component: () => import('/@/pages/page-web/projects/task.vue'),
        children: [
          {
            path: ERouterName.CREATE_PLAN,
            name: ERouterName.CREATE_PLAN,
            component: CreatePlan,
            children: [
              {
                path: ERouterName.SELECT_PLAN,
                name: ERouterName.SELECT_PLAN,
                components: {
                  WaylinePanel,
                  DockPanel
                }
              }
            ]
          }

        ]
      },
      {
        path: '/' + ERouterName.FLIGHT_AREA,
        name: ERouterName.FLIGHT_AREA,
        component: () => import('/@/pages/page-web/projects/flight-area.vue')
      },
    ]
  },
  // pilot
  {
    path: '/' + ERouterName.PILOT,
    name: ERouterName.PILOT,
    component: () => import('/@/pages/page-pilot/pilot-index.vue'),
  },
  {
    path: '/' + ERouterName.PILOT_HOME,
    component: () => import('/@/pages/page-pilot/pilot-home.vue')
  },
  {
    path: '/' + ERouterName.PILOT_MEDIA,
    component: () => import('/@/pages/page-pilot/pilot-media.vue')
  },
  {
    path: '/' + ERouterName.PILOT_LIVESHARE,
    component: () => import('/@/pages/page-pilot/pilot-liveshare.vue')
  },
  {
    path: '/' + ERouterName.PILOT_BIND,
    component: () => import('/@/pages/page-pilot/pilot-bind.vue')
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router
